import { useEffect } from "react";
import PropTypes from "prop-types";
import { reportAppHydrated } from "src/utilities/hydrationReporting";

// Renders nothing; its effect firing proves React committed the hydrated tree
const HydrationHeartbeat = ({ initialState }) => {
  useEffect(() => {
    reportAppHydrated(initialState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

HydrationHeartbeat.propTypes = {
  initialState: PropTypes.object,
};

export default HydrationHeartbeat;
